import $ from './el.JsModules.js';

elabs.QuoteView = class {
  'use strict';

  constructor(element) {
    this.view = $(element);

    this.currentQuoteIndex = 0;

    this.quoteContainer = this.view.find('.el-quote__container');
    this.quotesData = this.quoteContainer.data('quotes');
    this.quoteContainer.removeAttr('data-quotes'); // clean up DOM

    const viewId = this.view.attr('id');
    this.QUOTE_SETTINGS_KEY = 'el-quote-settings-key--' + viewId;

    this.shouldRandomise = this.quoteContainer.data('should-randomise');
    if (this.shouldRandomise) {
      let quoteSettings = JSON.parse(localStorage.getItem(this.QUOTE_SETTINGS_KEY));
      if (!quoteSettings) {
        quoteSettings = {};
        quoteSettings.initialOffset = 0;
      }

      this.quotesData = this.quotesData.rotate(quoteSettings.initialOffset); // this sets the first slide as one they haven't maybe seen yet
      quoteSettings.initialOffset++;

      localStorage.setItem(this.QUOTE_SETTINGS_KEY, JSON.stringify(quoteSettings));
    }

    this.prepareQuoteAtIndex(this.currentQuoteIndex);
    this.initialiseIntersectionObservers();

    this.wireEvents();
  }

  wireEvents() {
    this.view.find('.el-quote__nav-button--right').click(() => {
      this.handleNavClick(true);
    });

    this.view.find('.el-quote__nav-button--left').click(() => {
      this.handleNavClick(false);
    });
  }

  initialiseIntersectionObservers() {
    const entranceObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // console.log('View is in the middle of the viewport');
            this.performAppearanceAnimation();
          }
        });
      },
      {
        rootMargin: '-30% 0% -30% 0%', // This makes sure the animation starts when the quote is 80px from the top of the viewport
      },
    );

    const almostFullyVisibleObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.8) {
            // Element is at least 50% visible
            this.performAppearanceAnimation();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, // Trigger when at least half of the element is in view
      },
    );

    const exitObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          this.quoteElement.removeClass('el-quote--animated');
          // console.log('View has FULLy exited the viewport');
        }
      });
    });

    entranceObserver.observe(this.view[0]);
    almostFullyVisibleObserver.observe(this.view[0]);
    exitObserver.observe(this.view[0]);
  }

  handleNavClick(forward) {
    this.view.animate({ opacity: 0 }, 300, () => {
      this.reset();
      this.view.css('opacity', 1);
      if (forward) {
        this.currentQuoteIndex++;
      } else {
        this.currentQuoteIndex--;
      }

      this.currentQuoteIndex = this.currentQuoteIndex.mod(this.quotesData.length);

      if (this.shouldRandomise) {
        const quoteSettings = JSON.parse(localStorage.getItem(this.QUOTE_SETTINGS_KEY));
        quoteSettings.initialOffset++;
        localStorage.setItem(this.QUOTE_SETTINGS_KEY, JSON.stringify(quoteSettings));
      }

      this.prepareQuoteAtIndex(this.currentQuoteIndex);
      this.performAppearanceAnimation();
    });
  }

  prepareQuoteAtIndex(index) {
    const quote = this.quotesData[index];
    this.quoteContainer.html(quote);
    this.quoteElement = this.view.find('.el-quote');
    if (this.quoteElement.data('original-quote-text')) {
      this.quoteElement.html(this.quoteElement.data('original-quote-text'));
      this.quoteElement.removeClass('el-quote--animated');
    } else {
      this.quoteElement.data('original-quote-text', this.quoteElement.html());
    }

    const lettersToAnimate = this.view.find('.el-quote__letters');
    const allTextNodes = elabs.Utils.getTextNodes(lettersToAnimate);
    allTextNodes.forEach((textNode) => {
      elabs.Utils.wrapEachCharacter(textNode);
    });
  }

  performAppearanceAnimation() {
    requestTimeout(() => {
      this.quoteElement.addClass('el-quote--animated');
    }, 2);
  }

  reset() {
    if (this.quoteElement) {
      this.quoteElement.removeClass('el-quote--animated');
      this.quoteElement.html('');
    }
  }
};

// Initialise all Quotes
elabs.onJavascriptReady(function () {
  $('.el-quotes').each(function (index, element) {
    new elabs.QuoteView(element);
  });
});
